import { Typography } from "@material-ui/core";
import * as React from "react";
import BaseFilter from "../../../core/models/BaseFilter";
import TankModel from "../../../core/models/Tank";
import {
  EVENT_EXPORT_EXCEL_TRIPS_HISTORY,
  EVENT_EXPORT_PDF_TRIPS_HISTORY,
  EVENT_INSTALLATION_TRIPS_HISTORY_FILTER_DATE_CHANGE,
  EVENT_INSTALLATION_TRIPS_HISTORY_FILTER_TANK_CHANGE,
  EVENT_INSTALLATION_TRIPS_HISTORY_SPLIT_TANKS_CHANGE,
} from "../../../Events";
import MaterialCustomSelectDate from "../../../features/SmartFilters/MaterialCustomSelectDate";
import { useHubx } from "../../../HubX";
import ButtonExport from "../../ButtonExport";
import ButtonSwitch from "../../ButtonSwitch";
import MaterialSelect from "../../MaterialSelect";

type InstallationTripsHistoryFilterProps = {
  tanks?: TankModel[];
  hasMoreThanOneTank?: boolean;
};

function InstallationTripsHistoryFilter({
  tanks,
  hasMoreThanOneTank = false,
}: InstallationTripsHistoryFilterProps) {
  const hub = useHubx();

  const handleClickExportExcel = () => {
    hub.notify(EVENT_EXPORT_EXCEL_TRIPS_HISTORY, true);
  };

  const handleClickExportPdf = () => {
    hub.notify(EVENT_EXPORT_PDF_TRIPS_HISTORY, true);
  };

  return (
    <>
      <ButtonExport
        label="Exportar"
        onClickExcel={handleClickExportExcel}
        onClickPdf={handleClickExportPdf}
      />

      <MaterialCustomSelectDate event={EVENT_INSTALLATION_TRIPS_HISTORY_FILTER_DATE_CHANGE} initialSelectionKey={4} />
    </>
  );
}

export default InstallationTripsHistoryFilter;
